import { Injectable } from '@angular/core';

import { PcvizProject, PcvizMapView, PcvizSitesMapViewer, PcvizJobSite, PcvizJobSiteMapView } from '@mirage-projects/cw-models';

@Injectable({ providedIn: 'root' })
export class MapPcvizService {
    createMapView(pcvizProject: PcvizProject, element: HTMLElement | null): PcvizMapView {
        return new PointCloudVizMap.default.Map.MapView(pcvizProject, element);
    }

    createSitesMapViewer(element: HTMLElement | null): PcvizSitesMapViewer {
        return new PointCloudVizMap.default.Map.SitesMapViewer(element);
    }

    createJobsiteMapView(pcvizJobSite: PcvizJobSite, element: HTMLElement | null): PcvizJobSiteMapView {
        return new PointCloudVizMap.default.Map.JobSiteMapView(pcvizJobSite, element);
    }
}
